import { composeClassNames } from "@faedev/editor-utils";
import { Col, Row } from "react-bootstrap";
import Heading from "src/components/Heading";
import gutter from "src/functions/gutter";
import { sAlign } from "src/styles/sAlign.module.scss";
import { sList } from "src/styles/sList.module.scss";

function UserTermsPrivacyEn6() {
  return (
    <div>
      <Heading
        type={`h3`}
        title={
          <>
            {`VI.`}
            <br />
            {`Terms of service`}
          </>
        }
        className={composeClassNames([sAlign, "center"])}
        style={gutter(`margin`, `top`, `md`)}
      />
      <Row>
        <Col sm={6} xs={12}>
          <ol className={sList}>
            <li>{`The User may not disseminate information within the service, the content of which is in conflict with good morals or generally binding legal regulations.`}</li>
            <li>{`The User may not use within the service mechanisms, tools, software or procedures that have or could have a negative impact on the operation of the service.`}</li>
            <li>{`The User may not engage in activities aimed at disabling or restricting the operation of the service or the server of the Provider on which the service is operated, or perform other attacks on this server, nor may they assist third parties in such activities. The User may not use the User account and the service in a way that would unreasonably restrict the use of the service by other customers of the Provider or otherwise unreasonably restrict the Provider.`}</li>
          </ol>
        </Col>
        <Col sm={6} xs={12}>
          <ol start={4} className={sList}>
            <li>{`Access data to the service are intended only for one natural person, or for a common household within a family subscription, and are non-transferable. The User has no right to provide, assign, rent, lend or otherwise provide third parties with access to the service, permanently or temporarily, for a fee or free of charge, without the prior written consent of the Provider. The User is not entitled to share access data between several natural persons, even if the User is a legal entity, in which case the legal entity is obliged to designate one natural person who will have access to the service. In case of loss of access data or suspicion of their misuse or leakage, the User is obliged to immediately inform the Provider. The Provider is not liable for damage that would occur to the User by abusing access to the service without the fault of the Provider. In case of suspicion of sharing access to the service, the Provider is entitled to suspend the User's access to the service for the necessary period of time, provided that the right to payment for the relevant period is not affected.`}</li>
          </ol>
        </Col>
      </Row>
    </div>
  );
}

export default UserTermsPrivacyEn6;
